import {
  fork,
  call,
  put,
  takeLatest,
  select /* take, cancel */,
} from "redux-saga/effects";
import { browserHistory } from "react-router";
import request, { requestImage } from "utils/request";
import {
  setUserType,
  setAccessToken,
  getAccessToken,
  isAccessTokenExpired,
} from "utils/helpers";
import actionsWatcherSaga from "redux-saga-actions";
import {
  SIGN_IN,
  RESET_PW,
  LOAD_USER,
  LOAD_INITIAL_DATA,
  TTLOGGER_EVENTLOG,
  TTLOGGER_USER_ID,
  LOAD_USER_IMAGE,
  SEND_MAIL,
  ACCEPT_PRIVACY,
  ACCEPT_TOS,
  SIGN_IN_SUCCESS,
} from "./constants";
import {
  signInSuccess,
  signInError,
  resetPasswordSuccess,
  resetPasswordError,
  sendMailError,
  sendMailSuccess,
  // loadUserImage,
  loadUserImageSuccess,
  loadUser,
  loadUserSuccess,
  loadUserError,
  loadInitialDataSuccess,
  loadInitialDataError,
  setTTloggerUserId,
  ttloggerUserID,
  acceptTermsSuccess,
  loadAcceptedPages,
  acceptPrivacySuccess,
} from "./actions";
import messages from "./messages";

const REACT_APP_TT_LOGGER_KEY = "985d16a0-ca51-4131-976e-708a40749056";
const REACT_APP_TT_LOGGER_URL = "https://logger.tribaltech.com/logger/v2";

export function* onWatchSignIn(action) {
  try {
    const { credentials, targetPage } = action;
    const options = {
      method: "post",
      body: {
        ...credentials,
        client_id: "REWARDS",
        scope: "all",
        grant_type: "password",
      },
    };
    const response = yield call(request, "/oauth/token", options);
    yield put(signInSuccess(response));
    yield put(loadUser());
    // eslint-disable-next-line no-unused-expressions
    !targetPage
      ? browserHistory.push("/home/all")
      : browserHistory.push(targetPage);
  } catch (err) {
    //  console.error(err); // eslint-disable-line no-console
    yield put(signInError(messages.signInError));
  }
}

export function* onWatchSignInSuccess(action) {
  setAccessToken(action.response);
  setUserType("false");
}

export function* onWatchResetPassword(action) {
  try {
    const { password, token } = action;
    const options = {
      method: "post",
      body: {
        password,
        token,
      },
    };
    const response = yield call(request, "/user/reset_password", options);
    yield put(resetPasswordSuccess(response));
    browserHistory.push("/reset_password_successful");
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
    yield put(resetPasswordError(err));
  }
}
// TODO: Implement with backend

export function* onWatchSendmMail(action) {
  try {
    const options = {
      method: "post",
      body: { ...action.data },
    };
    const response = yield call(request, "/support/create_ticket", options);
    yield put(sendMailSuccess(response));
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
    yield put(sendMailError(err));
  }
}

export function* onWatchLoadInitialData() {
  try {
    yield put(loadUser());
    const [categories, profiles] = yield [
      call(request, "/rewards/categories"),
      call(request, "/sponsors"),
    ];
    yield put(loadInitialDataSuccess({ categories, profiles }));
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
    yield put(loadInitialDataError(err));
  }
}

export function* onWatchLoadUser() {
  const token = getAccessToken();
  if (token && !isAccessTokenExpired(token)) {
    try {
      const [user, points] = yield [
        call(request, "/user/info/false"),
        call(request, "/user/reward_user_points"),
      ];
      const response = user && {
        ...user,
        points,
      };
      const isAnonymousUser = response.isAnonymousUser === 0 ? "false" : "true";
      setUserType(isAnonymousUser);
      yield put(loadUserSuccess(response));
      // yield put(loadUserImage(response));
      yield put(ttloggerUserID(response));
      yield put(loadAcceptedPages(response));
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
      yield put(loadUserError(err));
    }
  }
}

export function* onWatchAcceptTerms() {
  try {
    yield call(request, "/user/accept_tos");
    yield put(acceptTermsSuccess());
    browserHistory.push("/pages/privacy");
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
    // yield put(loadPageError(err));
    // browserHistory.push('/home/all');
  }
}

export function* onWatchAcceptPrivacy() {
  try {
    yield call(request, "/user/accept_pp");
    yield put(acceptPrivacySuccess());
    browserHistory.push("/register-girls");
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
    // browserHistory.push('/home/all');
    //   yield put(loadPageError(err));
  }
}

export function* onWatchTTloggerUserId({ user }) {
  try {
    let userId = user ? user.userUniqueId : null;
    if (!userId) {
      userId = yield select((state) =>
        state.get("global").get("ttloggerUserId")
      );
    }
    let identity = [];
    if (user) {
      const validKeys = [
        "age",
        "gender",
        "email",
        "firstName",
        "lastName",
        "userId",
        "phone",
      ];
      identity = Object.entries(user)
        .filter(([key, value]) => validKeys.includes(key) && value)
        .reduce((acc, [key, value]) => {
          acc.push({ name: key, value });
          return acc;
        }, []);
    }
    const options = {
      method: "post",
      mode: "cors",
      body: {
        apiKey: REACT_APP_TT_LOGGER_KEY,
        action: "userID",
        identity,
      },
    };
    if (userId) {
      options.body.uuid = userId;
    }
    const response = yield call(
      request,
      REACT_APP_TT_LOGGER_URL,
      options,
      true
    );
    yield put(setTTloggerUserId(response.object.userId));
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
  }
}

export function* onwatchLoadUserImage({ user }) {
  try {
    const imageUrl = user ? user.imageUrl : null;
    if (imageUrl) {
      const options = {
        method: "get",
        mode: "cors",
      };
      const response = yield call(requestImage, imageUrl, options);
      yield put(loadUserImageSuccess(response));
    }
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
  }
}

export function* onWatchTTloggerEventlog({ name, value }) {
  try {
    const userId = yield select((state) =>
      state.get("global").get("ttloggerUserId")
    );
    const location = yield select((state) => ({
      lon: state.get("global").get("longitude"),
      lat: state.get("global").get("latitude"),
    }));
    const options = {
      method: "post",
      body: {
        apiKey: REACT_APP_TT_LOGGER_KEY,
        action: "eventLog",
        uuid: userId,
        events: [
          {
            name,
            value:
              name !== "pageview"
                ? value
                : {
                    __elapsedtime__: 2,
                    pagename: value.toString(),
                  },
            location,
            ts: Date.now(),
          },
        ],
      },
    };
    yield call(request, REACT_APP_TT_LOGGER_URL, options, true);
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
  }
}

export function* watchSignIn() {
  yield takeLatest(SIGN_IN, onWatchSignIn);
}

export function* watchSignInSuccess() {
  yield takeLatest(SIGN_IN_SUCCESS, onWatchSignInSuccess);
}

export function* watchResetPassword() {
  yield takeLatest(RESET_PW, onWatchResetPassword);
}
export function* watchSendMail() {
  yield takeLatest(SEND_MAIL, onWatchSendmMail);
}

export function* watchLoadUser() {
  yield takeLatest(LOAD_USER, onWatchLoadUser);
}

export function* watchLoadInitialData() {
  yield takeLatest(LOAD_INITIAL_DATA, onWatchLoadInitialData);
}

export function* watchTTloggerEventlog() {
  yield takeLatest(TTLOGGER_EVENTLOG, onWatchTTloggerEventlog);
}

export function* watchTTloggerUserId() {
  yield takeLatest(TTLOGGER_USER_ID, onWatchTTloggerUserId);
}

export function* watchLoadUserImage() {
  yield takeLatest(LOAD_USER_IMAGE, onwatchLoadUserImage);
}

export function* watchAcceptTerms() {
  yield takeLatest(ACCEPT_TOS, onWatchAcceptTerms);
}

export function* watchAcceptPrivacy() {
  yield takeLatest(ACCEPT_PRIVACY, onWatchAcceptPrivacy);
}

export default function* appSagas() {
  yield fork(watchSignIn);
  yield fork(watchSignInSuccess);
  yield fork(watchResetPassword);
  yield fork(watchSendMail);
  yield fork(watchLoadUser);
  yield fork(watchLoadInitialData);
  yield fork(watchTTloggerEventlog);
  yield fork(watchTTloggerUserId);
  // yield fork(watchLoadUserImage);
  yield fork(watchAcceptTerms);
  yield fork(watchAcceptPrivacy);
  yield fork(actionsWatcherSaga);
}
